module.exports = __webpack_public_path__ + "static/media/rule_banner_mobile.baba0987.png";